import { useState, ReactNode, useEffect, useRef } from "react";
import {MapContainer, TileLayer, Marker, Popup, useMap} from "react-leaflet";
import L, { LatLngTuple } from "leaflet";
//--------------------------------------------------------------------------------------------
import youAreHere from "src/img/maps/youAreHere.png";
import check from "src/img/maps/check.png";
import Modal from "src/components/common/Modal";

import { json } from "src/components/common/types";
import { useAuthStore } from "src/components/main/authStore";
import {
    myAxios} from "src/components/common/functions";
//--------------------------------------------------------------------------------------------
//locationName, coordsName, location, coords, url
export default function AutoComplete({
    projectLocation, 
    projectCoords, 
    locationName, 
    coordsName, 
    location, 
    coords, 
    url, 
    className, 
    id
}:{
    projectLocation?: string, 
    projectCoords?: LatLngTuple, 
    locationName: string, 
    coordsName: string, 
    location: string, 
    coords?: LatLngTuple, 
    url?: string, 
    className: string, 
    id: string
}){
    const user = useAuthStore(state => state.user);
    //--------------------------------------------------------------------------------------------
    const [loc, setLoc] = useState(location || "");
    const typingTimeoutRef = useRef<number | null>(null);
    const [predictions, setPredictions] = useState<ReactNode[]>([]);
    //!?.split(",").map(Number)
    const [currentCoords, setCurrentCoords] = useState<LatLngTuple>(
        coords || user!.coords || [37.6148826, -122.0852843]
    );
    const [showModal, setShowModal] = useState(false);
    //--------------------------------------------------------------------------------------------
    const youAreHereIcon = L.icon({
        iconUrl: youAreHere,
        iconSize: [50, 60]
    });
    //--------------------------------------------------------------------------------------------
    return(
        <div className = {(className ?? "") + " d-flex align-items-center"}>
            {loc?<span className = "text-success me-3">{loc}</span>:null}
            <button
                type = "button"
                id = {id}
                className = {`me-3 btn btn-primary`}
                onClick = {e => {
                    e.currentTarget.blur();setShowModal(true);
                }}
            >
                Set Location
            </button>
            {projectCoords && projectLocation?
            <button
                type = "button"
                id = {id}
                className = {`btn btn-info`}
                onClick = {() => {
                    setLoc(projectLocation);
                    setCurrentCoords(projectCoords);
                }}
            >
                Get Location From Project
            </button>:null}
            <input
                className = "nodisplay" readOnly
                name = {locationName} value = {loc}
            />
            <input
                className = "nodisplay" readOnly
                name = {coordsName} // output to higher level
                value = {
                    JSON.stringify(currentCoords) === JSON.stringify(user!.coords || [37.6148826, -122.0852843])?
                    ""
                    :
                    currentCoords.join(",")
                }
            />
            {showModal?
            <Modal 
                width = {"100%"}
                maxWidth = {1000}
                title = {"Map"} 
                onSave = {() => setShowModal(false)} 
                closeIt = {() => {
                    setShowModal(false);
                    setLoc("");
                    setCurrentCoords(user!.coords! || [37.6148826, -122.0852843]);
                    setPredictions([]);
                }}
            >
                <div style = {{height: 600}}>
                    <MapContainer
                        center = {user!.coords || [37.6148826, -122.0852843]}
                        zoom = {12}
                        scrollWheelZoom = {true}
                    > 
                        <TileLayer
                            attribution = ""
                            url = "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                        />
                        <Marker position = {user!.coords! || [37.6148826, -122.0852843]} icon = {youAreHereIcon}/>
                        <Locate
                            url = {url}
                            setCurrentCoords = {setCurrentCoords}
                            setLoc = {setLoc}
                            currentCoords = {currentCoords}
                            flyCoords = {currentCoords}
                        />
                    </MapContainer>
                </div>
                <input 
                    className = "form-control" 
                    style = {{
                        position:"absolute", 
                        right:"50px", 
                        top:"25px", 
                        width:"65%",
                        /*maxWidth: 500,*/
                        paddingRight: 40
                    }} 
                    autoComplete = "off" 
                    type = "text" 
                    value = {loc} 
                    required 
                    onKeyDown = {e => {
                        if(e.key === "Enter"){
                            e.preventDefault(); 
                        }
                    }}
                    onChange = {e => {
                        const searchText = e.currentTarget.value;
                        setLoc(searchText);
                        if(typingTimeoutRef.current){
                            window.clearTimeout(typingTimeoutRef.current);
                            setPredictions([]);
                        };
                        if(!searchText) return;
                        typingTimeoutRef.current = window.setTimeout(async () => {
                            const formData = new FormData();
                            formData.append("string", encodeURI(searchText));
                            const res: false | json  = await myAxios({ fileName: "common/autocomplete.php", formData: formData });
                            if(!res) return;
                            if(!res.data.predictions.length){
                                setPredictions([
                                    <div 
                                        key = {0} 
                                        style = {{
                                            backgroundColor: "gray", 
                                            pointerEvents: "none", 
                                            borderRadius: 6
                                        }}
                                    >
                                        No match
                                    </div>
                                ]);
                            }else{
                                setPredictions(
                                    res.data.predictions.map(({place_id, description}:{place_id:string, description:string}, index:number) => 
                                        <div
                                            key = {index} 
                                            onClick = {async e => {
                                                setLoc(e.currentTarget.innerText);
                                                setPredictions([]);
                                                const formData = new FormData();
                                                formData.append("location", place_id);
                                                //-----------------------------------------
                                                const res: false | json = await myAxios({ fileName: "common/autocomplete.php", formData: formData });
                                                if(!res) return;
                                                //-----------------------------------------
                                                const cord = res.data.result.geometry.location;
                                                setCurrentCoords([cord.lat, cord.lng]);
                                            }}
                                        >
                                            {description}
                                        </div>
                                    )
                                );
                            }
                        }, 500);
                    }}
                /><img src = {check} alt = "" style  = {{
                    width: "30px", 
                    position: "absolute", 
                    zIndex:1,  
                    right:"55px", 
                    top:"30px",
                }}/>
                {predictions.length?<div className = "autocomplete" style = {{
                    position:"absolute", 
                    width:"400px", 
                    right:"50px", 
                    top:"63px", 
                    backgroundColor:"white"
                }}>{predictions}</div>
                :null}
            </Modal>:null}
        </div>
    )
}
//--------------------------------------------------------------------------------------------
function Locate({
    url, 
    setCurrentCoords, 
    setLoc, 
    currentCoords, 
    flyCoords 
}:{
    url?: string, 
    setCurrentCoords: Function, 
    setLoc: Function, 
    currentCoords: LatLngTuple, 
    flyCoords: LatLngTuple 
}){
    const locationIcon = L.icon({
        iconUrl: url || "https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon-2x.png",
        iconSize: [30, 50]
    });
    const map = useMap();
    useEffect(() => {
        if (!map || !flyCoords) return;
        map.flyTo(flyCoords, map.getZoom(), {
            animate: true,
            duration: 0.8,
        });
    }, [map, flyCoords]);
    return(
    <Marker position = {flyCoords} draggable = {true} icon = {locationIcon} eventHandlers = {{
        dragend: pos => {
            setCurrentCoords([pos.target._latlng.lat, pos.target._latlng.lng]);
            setLoc("");
        },
    }}>
        <Popup>
            <div className = "p-2 mt-3" style  = {{fontSize: 15}}>
                <span className = "fw-bold me-2">Coordinates:</span>
                {`[${Math.round(currentCoords[0] * 100) / 100}... , ${Math.round(currentCoords[1] * 100) / 100}...]`}
            </div>
            <div className = "p-2 mt-1" style  = {{fontSize: 15}}>
                <span className = "fw-bold me-2">Name:</span>
                <input className = "border p-1 rounded" style = {{outlineColor:"#007bff"}} type = "text"/>
            </div>
            <div
                className = "btn-primary mt-4 p-2 rounded text-center pointer"
                style = {{
                    width: "60%", 
                    marginLeft:"20%", 
                    fontSize: 15
                }}
                onClick = {e => {
                    const newAddress = (e.currentTarget.previousSibling?.childNodes[1] as HTMLInputElement).value;
                    if(newAddress === ""){
                        window.alert("Fill in the new address!");
                        return;
                    }else{
                        setLoc(newAddress);
                    }
                }}
            >
                Add this address
            </div>
        </Popup>
    </Marker>
    );
}